<div class="contenedor">
    <div class="contenedor_filter">
        <app-filter-table-simulations
            [states]="states"
            [approvators]="approvators"
            (filterState)="onSearchState($event)"
            (filterSearch)="onSearchInput($event)"
            (filterAprove)="onSearchAprove($event)"
        ></app-filter-table-simulations>
    </div>
    <div class="contenedor_table">   
        <div class="spinner">
            <mat-spinner style="margin-top: 50px;" [diameter]="60" *ngIf="load"></mat-spinner>
        </div>
        <app-table-simulations [ngClass]="{ oculto: load }"
            [cotizaciones]="cotizaciones"
            [page]="responsePage?.page" 
            [pageSize]="responsePage?.pageSize" 
            [totalRows]="responsePage?.totalItems"
            (quoteSelected)="receiveSelectedQuote($event)"
            (pagination)="onPagination($event)"
            (sorting)="onSort($event)"
            (reload)="reload($event)">
        </app-table-simulations>
    </div>
</div>